export default {
  parameter: {
    selectParameter: 'Selectează parametru',
    name: 'Introdu numele',
    min: 'Min.',
    max: 'Max.',
  },
};
